
import { defineComponent } from "vue";
import Modal from "../Components/Modal.vue";
import StickCard from "./StickCard.vue";

export default defineComponent({
  name: "SticksModal",

  data: () => ({
    usedStickId: 0,
    sticks: [
      {
        id: 1,
        name: "Raven",
        file: "1",
        stats: { force: 5, aim: 3, spin: 4, time: 5 },
      },
      {
        id: 2,
        name: "Blue Hope",
        file: "2",
        stats: { force: 4, aim: 5, spin: 4, time: 5 },
      },
      {
        id: 3,
        name: "Test Tube",
        file: "3",
        stats: { force: 8, aim: 5, spin: 4, time: 10 },
      },
      {
        id: 4,
        name: "Oak",
        level: 4,
        file: "4",
        stats: { force: 10, aim: 9, spin: 9, time: 9 },
      },
      {
        id: 5,
        name: "Posh",
        file: "5",
        stats: { force: 3, aim: 2, spin: 4, time: 3 },
      },
      {
        id: 6,
        name: "Bear-paw",
        file: "6",
        stats: { force: 3, aim: 2, spin: 4, time: 3 },
      },
      {
        id: 7,
        name: "Royal Blue",
        file: "7",
        stats: { force: 3, aim: 2, spin: 4, time: 3 },
      },
      {
        id: 8,
        name: "Crocodile",
        file: "8",
        stats: { force: 3, aim: 2, spin: 4, time: 3 },
      },
      {
        id: 9,
        name: "The Deputy",
        file: "9",
        stats: { force: 3, aim: 2, spin: 4, time: 3 },
      },
    ],
  }),

  components: { Modal, StickCard },
});
